import React, { useState } from "react";
import {
  TextField,
  Button,
  Box,
  Typography,
  Divider,
  Link,
  IconButton,
  InputAdornment,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import cidLogo from "../Images/cid_logo.png";
import OTPInputComponent from "../components/otp";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import { CircularProgress } from "@mui/material";

const Login = () => {
  const [kgid, setKGID] = useState("");
  const [pin, setPin] = useState("");
  const [confirmPin, setConfirmPin] = useState("");
  const [otp, setOtp] = useState("");
  const [validationError, setValidationError] = useState("");
  const [loading, setLoading] = useState(false); // State for loading indicator
  const navigate = useNavigate();
  const [showOtp, setShowOtp] = useState(false);
  // Google Authenticator (TOTP) enrollment view: shown on first login before a code is entered.
  const [showQr, setShowQr] = useState(false);
  const [qrImage, setQrImage] = useState("");
  const [manualSecret, setManualSecret] = useState("");
  const [showDesignation, setShowDesignation] = useState(false);
  const [user_position, setUserPosition] = useState([]);
  const [tempToken, setTempToken] = useState("");
  const [forgotPassword, setForgotPassword] = useState(false);
  const [forgotVerifyOtp, setForgotVerifyOtp] = useState(false);
  const [forgotPin, setForgotPin] = useState(false);
  const [usersDesignations, setUsersDesignations] = useState({});
  const [usersDivision, setUsersDivision] = useState({});
  // Toggle masking for the reset-PIN fields (eye icon).
  const [showResetPin, setShowResetPin] = useState(false);
  const [showResetConfirmPin, setShowResetConfirmPin] = useState(false);

    const handleSubmit = async (e) => {
        setValidationError("");
        e.preventDefault();
        setLoading(true);

        try {
            if (!kgid || !pin || isNaN(kgid) || isNaN(pin)) {
                setValidationError("Please enter valid KGID and PIN");
                setLoading(false);
                return;
            }

            const serverURL = process.env.REACT_APP_SERVER_URL;
            const response = await fetch(`${serverURL}/auth/generate_OTP`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ kgid: kgid, pin: pin }),
            });

            const data = await response.json();
            if (!response.ok) {
                throw new Error(data.message);
            }

            if (data && data.enrolled === false) {
                // First-time login: show the QR to scan before the user can enter a code.
                setQrImage(data.qr || "");
                setManualSecret(data.secret || "");
                setShowQr(true);
            } else {
                // Already enrolled: just prompt for the 6-digit authenticator code.
                setShowOtp(true);
            }
            setLoading(false);
        } catch (err) {
            //in err Error: You have exceeded the maximum number of attempts
            setLoading(false);
            setLoading(false);
            var errMessage = "Something went wrong. Please try again.";
            if (err && err.message) {
                errMessage = err.message;
            }
            setValidationError(errMessage);
        }
    };

    const handleForgotPin = async (e) => {
        setValidationError("");
        e.preventDefault();
        setLoading(true);

        try {
            if (!kgid || isNaN(kgid)) {
                setValidationError("Please enter valid KGID");
                setLoading(false);
                return;
            }

            const serverURL = process.env.REACT_APP_SERVER_URL;
            const response = await fetch(
                `${serverURL}/auth/generate_OTP_without_pin`,{
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ kgid: kgid }),
                }
            );

            const data = await response.json();
            if (!response.ok) {
                throw new Error(data.message);
            }

            setShowOtp(false);
            setForgotVerifyOtp(true);
            setForgotPassword(false);
            setLoading(false);

        } catch (err) {
        //in err Error: You have exceeded the maximum number of attempts
            setLoading(false);
            setLoading(false);
            var errMessage = "Something went wrong. Please try again.";
            if (err && err.message) {
                errMessage = err.message;
            }
            setValidationError(errMessage);
        }
    };

  const handleforgotOtpVerify = async (e) => {
    setValidationError("");
    e.preventDefault();
    setLoading(true);

    try {
      const serverURL = process.env.REACT_APP_SERVER_URL;
      const response = await fetch(`${serverURL}/auth/verify_OTP_without_pin`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ kgid: kgid, otp: otp }),
      });

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message);
      }
      setShowOtp(false);
      setForgotVerifyOtp(false);
      setForgotPassword(false);
      setForgotPin(true);
      setLoading(false);
    } catch (err) {
      //in err Error: You have exceeded the maximum number of attempts
      setLoading(false);
      setLoading(false);
      var errMessage = "Something went wrong. Please try again.";
      if (err && err.message) {
        errMessage = err.message;
      }
      setValidationError(errMessage);
    }
  };

  const handleforgotPinLogin = async (e) => {
    setValidationError("");
    e.preventDefault();
    setLoading(true);

    // PIN must be exactly 6 digits and match the confirmation before we submit.
    if (!/^\d{6}$/.test(pin)) {
      setValidationError("PIN must be exactly 6 digits.");
      setLoading(false);
      return;
    }
    if (pin !== confirmPin) {
      setValidationError("PIN and Confirm PIN do not match.");
      setLoading(false);
      return;
    }

    try {
      const serverURL = process.env.REACT_APP_SERVER_URL;
      const response = await fetch(`${serverURL}/auth/update_pin`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ kgid: kgid, pin: pin }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message);
      }
      if (data && data.success) {
        toast.success(data.message || "PIN updated Successfully", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          className: "toast-success",
          onOpen: () => {
            setShowOtp(false);
            setForgotVerifyOtp(false);
            setForgotPassword(false);
            setForgotPin(false);
            setLoading(false);
            setConfirmPin("");
            setPin("");
            setKGID("");
            setOtp("");
          },
        });
      }
    } catch (err) {
      const errMessage =
        err?.message || "Something went wrong. Please try again.";
      setValidationError(errMessage);
    } finally {
      setLoading(false);
    }
  };

  const verifyOtp = async (e) => {
    setValidationError("");
    e.preventDefault();
    setLoading(true);
    try {
      const serverURL = process.env.REACT_APP_SERVER_URL;
      const response = await fetch(`${serverURL}/auth/verify_OTP`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ kgid: kgid, otp: otp }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message);
      }

      // console.log('data',data);
      // console.log('data.user_position',data.user_position);
      // console.log('data.user_role_permissions',data.user_role_permissions);

      if (data && data.user_role_permissions) {
        // localStorage.setItem('user_permissions', data.user_role_permissions);
        localStorage.setItem(
          "user_permissions",
          JSON.stringify(data.user_role_permissions)
        );
      }

       if(data.allowedUserIds)
        {
            localStorage.setItem("allowedUserIds",JSON.stringify(data.allowedUserIds));
        }


      if (data && data.userRole) {
        localStorage.setItem(
          "user_id",
          JSON.stringify(data.userRole.user_id)
        );
      }

       if (data && data.user_role_permissions) {
        localStorage.setItem("role_id",JSON.stringify(data.user_role_permissions[0].role_id));
        localStorage.setItem("role_title",JSON.stringify(data.user_role_permissions[0].role_title));
      }

      if (data && data.users_designation) {
        setUsersDesignations(data.users_designation);
      }

      if (data && data.users_division) {
        setUsersDivision(data.users_division);
      }

      if (data && data.user_position) {
        const user_position = data.user_position;
        if (user_position.length === 1 || user_position.length === 0) {
          if (data && data.token) {
            localStorage.setItem("auth_token", data.token);
            // Per-browser-session marker: cleared when the browser fully closes,
            // so reopening the app forces a fresh login (see AuthContext).
            sessionStorage.setItem("session_active", "1");
            localStorage.setItem("kgid", kgid);
            localStorage.setItem("username", data.user_detail.name);

            if (
              data.users_designation[0] &&
              data.users_designation[0].designation &&
              data.users_designation[0].designation.designation_name &&
              data.users_designation[0].designation_id
            ) {
              localStorage.setItem(
                "designation_id",
                data.users_designation[0].designation_id
              );
              localStorage.setItem(
                "designation_name",
                data.users_designation[0].designation.designation_name
              );
            }

            if (
              data.users_division[0] &&
              data.users_division[0].division &&
              data.users_division[0].division.division_name &&
              data.users_division[0].division_id
            ) {
              localStorage.setItem(
                "division_id",
                data.users_division[0].division_id
              );
              localStorage.setItem(
                "division_name",
                data.users_division[0].division.division_name
              );
            }

            // if(data.userRole.user_id === 1){
            //     navigate("/dashboard");
            // }else{
            //     navigate("/case/ui_case");
            // }
            setLoading(true);
            setUserHierarachy();
            setLoading(false);

          }
        } else if (user_position.length > 1) {
          if (data && data.token) {
            localStorage.setItem("auth_token", data.token);
            sessionStorage.setItem("session_active", "1");
            localStorage.setItem("kgid", kgid);
            localStorage.setItem("username", data.user_detail.name);
            setTempToken(data.token);
          }
          setUserPosition(user_position);
          setShowDesignation(true);
        }
      }

      setOtp("");
      setLoading(false);
      // setShowOtp(false);
    } catch (err) {
      setLoading(false);
      var errMessage = "Something went wrong. Please try again.";
      if (err && err.message) {
        errMessage = err.message;
      }
      setValidationError(errMessage);
    }
  };

    const designationClick = (item) => {
        console.log("Clicked Item:", item); // Check if item is received correctly
        localStorage.setItem("auth_token", tempToken);
        sessionStorage.setItem("session_active", "1");
        localStorage.setItem("kgid", kgid);

        for (let i = 0; i < usersDesignations.length; i++) {
        if (
            usersDesignations[i] &&
            usersDesignations[i].designation &&
            usersDesignations[i].designation_id &&
            usersDesignations[i].designation.designation_name &&
            usersDesignations[i].designation.designation_name == item.designation
        ) {
            localStorage.setItem(
            "designation_id",
            usersDesignations[i].designation_id
            );
            localStorage.setItem(
            "designation_name",
            usersDesignations[i].designation.designation_name
            );
        }
        }

        for (let i = 0; i < usersDivision.length; i++) {
            if (
                usersDivision[i] &&
                usersDivision[i].division &&
                usersDivision[i].division_id &&
                usersDivision[i].division.division_name &&
                usersDivision[i].division.division_name == item.divisions
            ) {
                localStorage.setItem("division_id", usersDivision[i].division_id);
                localStorage.setItem(
                "division_name",
                usersDivision[i].division.division_name
                );
            }
        }
        setUserHierarachy();
    };

    const setUserHierarachy = async () => {
        var selected_designation_id =localStorage.getItem("designation_id") || "0";
        var selected_designation_name = localStorage.getItem("designation_name") || "";
        var login_user_id = localStorage.getItem("user_id") || "0";
        setLoading(true);
        try {
            const serverURL = process.env.REACT_APP_SERVER_URL;
            const response = await fetch(`${serverURL}/auth/set_user_hierarchy`, {
                method: "POST",
                headers: {
                "Content-Type": "application/json",
                },
                body: JSON.stringify({ user_id: login_user_id, designation_id: selected_designation_id , designation_name: selected_designation_name }),
            });

            const data = await response.json();
            if (!response.ok) {
                throw new Error(data.message);
            }

            const responseData = data.data;        
            if (data && data.success && !responseData.getDataBasesOnUsers) {
                // localStorage.setItem("allowedUserIds",JSON.stringify(responseData.allowedUserIds));
                localStorage.setItem("allowedDepartmentIds",JSON.stringify(responseData.allowedDepartmentIds));
                localStorage.setItem("allowedDivisionIds",JSON.stringify(responseData.allowedDivisionIds));
                localStorage.setItem("getDataBasesOnUsers",JSON.stringify(responseData.getDataBasesOnUsers));
            }  
            else
            {
                // localStorage.setItem("allowedUserIds",JSON.stringify(responseData.allowedUserIds));
                localStorage.setItem("allowedDepartmentIds",JSON.stringify(responseData.allowedDepartmentIds));
                localStorage.setItem("allowedDivisionIds",JSON.stringify(responseData.allowedDivisionIds));
                localStorage.setItem("getDataBasesOnUsers",JSON.stringify(responseData.getDataBasesOnUsers));
            } 

            const gettingLoginUserDivisons = user_position.map((position) => {
                const designation = usersDesignations.find(
                    (designation) => designation?.designation?.designation_name === position?.designation
                );
                const division = usersDivision.find(
                    (division) => division?.division?.division_name === position?.division
                );
                return {
                    ...position,
                    ...(designation || {}),
                    ...(division || {})
                };
            });

            localStorage.setItem("userOverallDesignation", JSON.stringify(gettingLoginUserDivisons));

            navigate("/dashboard");

        } catch (err) {
            //in err Error: You have exceeded the maximum number of attempts
            var errMessage = "Something went wrong. Please try again.";
            if (err && err.message) {
                errMessage = err.message;
            }
            setValidationError(errMessage);
        }
        
        setShowDesignation(false);
        setLoading(false);
    }

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh", // Full viewport height
      }}
    >
      <Box
        sx={{ maxWidth: 400, margin: "auto", padding: 3 }}
        inert={loading ? true : false}
      >
        <Box
          sx={{
            padding: 1,
            display: "flex",
            gap: "10px",
            alignItems: "center",
            justifyContent: "center",
            borderBottom: "1px solid #D0D5DD",
          }}
        >
          <img
            srcSet={`${cidLogo}?w=248&fit=crop&auto=format&dpr=2 2x`}
            src={`${cidLogo}?w=248&fit=crop&auto=format`}
            alt=""
            loading="lazy"
          />
          <Divider
            sx={{
              height: "50px",
              width: "1px",
              backgroundColor: "#D0D5DD",
              border: "none",
            }}
          />
          <Typography
            className="poppins"
            align="left"
            variant="h5"
            gutterBottom
            sx={{ fontWeight: 600 }}
          >
            Case Management
            <br />
            System
          </Typography>
          <Divider sx={{ marginTop: 1 }} />
        </Box>
        {validationError && (
          <Typography color="error">{validationError}</Typography>
        )}
        {!showOtp && !showQr && !forgotPassword && !forgotVerifyOtp && !forgotPin && (
          <form onSubmit={handleSubmit}>
            <TextField
              label="KGID"
              variant="outlined"
              fullWidth
              margin="normal"
              value={kgid}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  setKGID(value);
                }
              }}
              inputProps={{ maxLength: 10 }}
            />
            {/* <OTPInputComponent length={6} value={otp} onChange={setOtp} /> */}
            <TextField
              label="PIN"
              type="password"
              variant="outlined"
              fullWidth
              margin="normal"
              value={pin}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  setPin(value);
                }
              }}
            />
            <Button
              type="submit"
              variant="contained"
              fullWidth
              sx={{ marginTop: 2 }}
            >
              Generate OTP
            </Button>
          </form>
        )}
        {!showOtp && forgotPassword && (
          <form onSubmit={handleForgotPin}>
            <TextField
              label="KGID"
              variant="outlined"
              fullWidth
              margin="normal"
              value={kgid}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  setKGID(value);
                }
              }}
              inputProps={{ maxLength: 10 }}
            />
            <Button
              type="submit"
              variant="contained"
              fullWidth
              sx={{ marginTop: 2 }}
            >
              Generate OTP
            </Button>
          </form>
        )}

        {showQr && (
          <form onSubmit={verifyOtp}>
            <Typography
              className="poppins"
              align="left"
              variant="h6"
              gutterBottom
              sx={{ fontWeight: 600 }}
            >
              Set up Google Authenticator
            </Typography>
            <Typography variant="body2" sx={{ color: "#555", mb: 1 }}>
              Scan this QR code with the Google Authenticator app, then enter the
              6-digit code it shows to finish setup and log in.
            </Typography>
            {qrImage && (
              <Box sx={{ display: "flex", justifyContent: "center", my: 1 }}>
                <img
                  src={qrImage}
                  alt="Google Authenticator QR code"
                  style={{ width: 200, height: 200 }}
                />
              </Box>
            )}
            {manualSecret && (
              <Typography
                variant="caption"
                sx={{
                  display: "block",
                  textAlign: "center",
                  color: "#667085",
                  mb: 1,
                  wordBreak: "break-all",
                }}
              >
                Can&apos;t scan? Enter this key manually: <b>{manualSecret}</b>
              </Typography>
            )}
            <Typography
              className="poppins"
              align="left"
              variant="subtitle1"
              gutterBottom
              sx={{ fontWeight: 600, mt: 1 }}
            >
              Enter Authenticator Code
            </Typography>
            <OTPInputComponent length={6} value={otp} onChange={setOtp} />

            <Button
              type="submit"
              variant="contained"
              fullWidth
              sx={{ marginTop: 2 }}
            >
              Verify &amp; Login
            </Button>
          </form>
        )}
        {showOtp && (
          <form onSubmit={verifyOtp}>
            <Typography
              className="poppins"
              align="left"
              variant="h6"
              gutterBottom
              sx={{ fontWeight: 600 }}
            >
              Enter Authenticator Code
            </Typography>
            <OTPInputComponent length={6} value={otp} onChange={setOtp} />

            <Button
              type="submit"
              variant="contained"
              fullWidth
              sx={{ marginTop: 2 }}
            >
              Login
            </Button>
          </form>
        )}
        {!showOtp && forgotVerifyOtp && (
          <form onSubmit={handleforgotOtpVerify}>
            <Typography
              className="poppins"
              align="left"
              variant="h6"
              gutterBottom
              sx={{ fontWeight: 600 }}
            >
              Enter Authenticator Code
            </Typography>
            <Typography variant="body2" sx={{ color: "#555", mb: 1 }}>
              Enter the 6-digit code from your Google Authenticator app to
              continue.
            </Typography>
            <OTPInputComponent length={6} value={otp} onChange={setOtp} />

            <Button
              type="submit"
              variant="contained"
              fullWidth
              sx={{ marginTop: 2 }}
            >
              Verify Code
            </Button>
          </form>
        )}

        {!showOtp && !forgotPassword && !forgotVerifyOtp && forgotPin && (
          <form onSubmit={handleforgotPinLogin}>
            <Typography
              className="poppins"
              align="left"
              variant="h6"
              gutterBottom
              sx={{ fontWeight: 600 }}
            >
              Reset PIN
            </Typography>
            <Typography variant="body2" sx={{ color: "#555", mb: 1 }}>
              Enter a 6-digit PIN to reset your login PIN.
            </Typography>
            <TextField
              label="Enter 6-digit PIN"
              type={showResetPin ? "text" : "password"}
              variant="outlined"
              fullWidth
              margin="normal"
              value={pin}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  setPin(value);
                }
              }}
              inputProps={{ maxLength: 6, inputMode: "numeric" }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle PIN visibility"
                      onClick={() => setShowResetPin((s) => !s)}
                      edge="end"
                    >
                      {showResetPin ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              label="Confirm 6-digit PIN"
              type={showResetConfirmPin ? "text" : "password"}
              variant="outlined"
              fullWidth
              margin="normal"
              value={confirmPin}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  setConfirmPin(value);
                }
              }}
              inputProps={{ maxLength: 6, inputMode: "numeric" }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle Confirm PIN visibility"
                      onClick={() => setShowResetConfirmPin((s) => !s)}
                      edge="end"
                    >
                      {showResetConfirmPin ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <Button
              type="submit"
              variant="contained"
              fullWidth
              sx={{ marginTop: 2 }}
            >
              Update Pin
            </Button>
          </form>
        )}

        {!showOtp && !showQr && !forgotPassword && !forgotVerifyOtp && !forgotPin && (
          <Box
            sx={{
              padding: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "end",
              borderBottom: "1px solid #D0D5DD",
              marginTop: 2,
            }}
          >
            <Link
              href="#"
              underline="none"
              onClick={() => setForgotPassword(true)}
            >
              {"Forgot PIN?"}
            </Link>
          </Box>
        )}
        {!showOtp && forgotPassword && (
          <Box
            sx={{
              padding: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "end",
              borderBottom: "1px solid #D0D5DD",
              marginTop: 2,
            }}
          >
            <Link
              href="#"
              underline="none"
              onClick={() => {
                setForgotPassword(false);
                setValidationError("");
                setKGID("");
                setPin("");
                setOtp("");
              }}
              sx={{ color: "red" }}
              auth
            >
              {"Cancel"}
            </Link>
          </Box>
        )}

        {loading && (
          <div className="parent_spinner" tabIndex="-1" aria-hidden="true">
            <CircularProgress size={100} />
          </div>
        )}
      </Box>
      <Dialog
        open={showDesignation}
        keepMounted
        onClose={() => setShowDesignation(false)}
        aria-describedby="alert-dialog-slide-description"
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box>
              <Typography
                variant="h3"
                style={{
                  fontWeight: "400",
                  fontSize: "18px",
                  color: "#1D2939",
                }}
              ></Typography>
              <Typography
                variant="h5"
                style={{
                  fontWeight: "600",
                  fontSize: "24px",
                  color: "#1D2939",
                }}
              >
                Choose your position
              </Typography>
            </Box>
            <Box
              p={1}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                background: "#EAECF0",
                borderRadius: "50%",
              }}
            >
              <svg
                onClick={() => setShowDesignation(false)}
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.6666 5.33447L5.33325 14.6678M5.33325 5.33447L14.6666 14.6678"
                  stroke="#667085"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Box>
          </Box>
        </DialogTitle>
        <DialogContent>
          {user_position.map((item) => (
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: 2,
                border: "1px solid #EAECF0",
                borderRadius: "5px",
                marginBottom: 2,
                cursor: "pointer",
              }}
              onClick={() => designationClick(item)}
            >
              <Box>
                <Typography
                  variant="h6"
                  style={{
                    fontWeight: "600",
                    fontSize: "18px",
                    color: "#1D2939",
                  }}
                >
                  {item.designation}
                </Typography>
                <Typography
                  variant="h6"
                  style={{
                    fontWeight: "400",
                    fontSize: "14px",
                    color: "#667085",
                  }}
                >
                  {item.designation_description}
                </Typography>
              </Box>
            </Box>
          ))}
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default Login;
